// All services are same-origin — the standalone binary serves everything.
export const ConfigConstants = {
  judgeapi_svc: '',
  kratos_svc: '/kratos'
};
export const inputValidation = {
  name: {
    pattern: '(?!.* {2})[A-Za-z0-9][A-Za-z0-9_ \\-\\(\\)]{2,63}',
    message: 'Name must be 3 to 64 characters long, start with an alphanumeric character, and may contain underscores, hyphens, single spaces, & parentheses.'
  },
  description: {
    pattern: '^[A-Za-z0-9][^$%^><!=*~`]+$',
    message: 'Description must not contain any of the following characters: $, %, ^, <, >, !, =, *, `, or ~'
  }
};